import store from './store'

// Global functions

var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i)
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i)
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i)
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i)
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i)
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows())
    }
}

function _detectMobile() {
	if (isMobile.any()) {
		$('body').addClass('body--mobile')
		store.commit('isMobile', true)
	}
}

function getRandomColor() {

	// let palette = [
	// 	'#EDBF00',
	// 	'#89603B',
	// 	'#D89EA5',
	// 	'#E21344',
	// 	'#346DB2',
	// 	'#AF9E54',
	// 	'#CAD3C7',
	// 	'#61646B',
	// 	'#E8D480',
	// 	'#6F5AA8',
	// 	'#47A06B',
	// 	'#D86B21',
	// 	'#E8E4D8',
	// 	'#6C3F3C',
	// 	'#6B9688',
	// 	'#D9BF9C',
	// 	'#83A7CB',
	// 	'#43423E',
	// 	'#295939',
	// 	'#E94A3D',
	// 	'#995CA0',
	// 	'#A8A8A8',
	// 	'#D8CBCA',
	// 	'#119CA3'
	// ]

	let palette = [
		'#00FFFF',
		'#7FFFD4',
		'#00FFFF',
		'#8A2BE2',
		'#A52A2A',
		'#DEB887',
		'#5F9EA0',
		'#7FFF00',
		'#D2691E',
		'#FF7F50',
		'#DEB887',
		'#5F9EA0',
		'#7FFF00',
		'#D2691E',
		'#FF7F50',
		'#6495ED',
		'#DC143C',
		'#00FFFF',
		//'#FFF8DC',
		'#00008B',
		'#008B8B',
		'#B8860B',
		'#A9A9A9',
		'#006400',
		'#BDB76B',
		'#8B008B',
		'#556B2F',
		'#FF8C00',
		'#9932CC',
		'#8B0000',
		'#E9967A',
		'#8FBC8F',
		'#483D8B',
		'#2F4F4F',
		'#00CED1',
		'#9400D3',
		'#FF1493',
		'#1E90FF',
		'#B22222',
		'#CD5C5C',
		'#7CFC00',
		'#F0E68C',
		'#FFB6C1',
		'#FFA07A',
		'#20B2AA',
		'#BA55D3',
		'#FFA500',
		'#FF4500',
		'#FFDAB9',
		'#BC8F8F',
		'#2E8B57',
		'#A0522D',
		'#D8BFD8',
		'#FF6347',
		'#00FF7F',
		'#4169E1',
		'#0000CD'
	]

	return palette[Math.floor(Math.random() * palette.length)]

}

function setupAjax() {

	if (history.pushState) {

		history.scrollRestoration = 'manual'

		window.history.replaceState({
			scrollTop: 0,
			path: wp.isHome ? null : window.location.pathname
		}, window.location.pathname, window.location.pathname)

		window.onpopstate = function(e) {

      e.preventDefault()

			//window.location.reload()

      console.log(e.state)

			if (e.state.path) {
				scrollToPosition(e.state.scrollTop)
			} else {
				window.location.href = '/'
			}

		}

	}

}

function scrollToPosition(offset, callback) {
	window.vm.$refs['main-container'].scrollTo(offset, () => {
		if (callback) callback()
	})
}

function getAll() {

	return new Promise(function(resolve) {

		let posts
		let pages

		$.when(
			$.ajax({
				url: wp.root + 'wp/v2/posts/',
				type: 'GET',
				cache: false,
				dataType: 'json',
				complete: function(json) {
					posts = json
				}
			}),
			$.ajax({
				url: wp.root + 'wp/v2/pages/',
				type: 'GET',
				dataType: 'json',
				complete: function(json) {
					pages = json
				}
			})
		).then(function() {
			console.log([posts, pages])
			resolve([posts, pages])
		})

	})

}

function getTaggedPosts(id) {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/posts/?tags=' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		})
	})
}

function getPermalinkFromID(id) {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'custom/permalink/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		})
	})
}

function getMultilineTitleFromID(id) {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'custom/multiline/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		})
	})
}

function getLexicon() {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/tags/',
			type: 'GET',
			cache: false,
			dataType: 'json',
			data: {
				'per_page': 100
			},
			complete: resolve,
			error: reject
		})
	})
}

function getSingleLexicon(id) {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/tags/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		})
	})
}

function getAuthors() {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/contributors/',
			type: 'GET',
			cache: false,
			dataType: 'json',
			data: {
				'per_page': 100
			},
			complete: resolve,
			error: reject
		})
	})
}

function getAuthorMeta(id) {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'custom/author-meta/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			data: {
				'per_page': 100
			},
			complete: resolve,
			error: reject
		})
	})
}

function getSingleAuthor(id) {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/contributors/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		})
	})
}

function getTimeline() {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/timeline/',
			type: 'GET',
			cache: false,
			dataType: 'json',
			data: {
				'per_page': 100
			},
			complete: resolve,
			error: reject
		})
	})
}

function getSingleTimeline(id) {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/timeline/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		})
	})
}

function getSingle(id) {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/posts/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		})
	})
}

function getPage(id) {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'wp/v2/pages/' + id,
			type: 'GET',
			cache: false,
			dataType: 'json',
			complete: resolve,
			error: reject
		})
	})
}

function getMenus() {
	return new Promise(function(resolve, reject) {
		$.ajax({
			url: wp.root + 'custom/menu/',
			type: 'GET',
			dataType: 'json',
			complete: resolve,
			error: reject
		})
	})
}

function updateMenuState(e) {
	store.commit('readyToShowUpArrow', true)
	store.commit('updateCurrentMenuItem', {
		id: $(e.currentTarget).data('id'),
		title: $(e.currentTarget).text()
	})
}

function doRequest(ajaxOpts, callback) {

	let ajaxMethod

	if (ajaxOpts.type == 'post' || ajaxOpts.type == undefined) {
		ajaxMethod = getSingle
	}

	if (ajaxOpts.type == 'contributors') {
		ajaxMethod = getSingleAuthor
	}

	if (ajaxOpts.type == 'page') {
		ajaxMethod = getPage
	}

	if (ajaxOpts.type == 'timeline') {
		ajaxMethod = getSingleTimeline
	}

	if (ajaxOpts.type == 'lexicon') {
		ajaxMethod = getSingleLexicon
	}

	ajaxMethod(ajaxOpts.id).then((p) => {
		let post = p
		post.doAnimation = true
		post.color = ajaxOpts.color
		post.slug = ajaxOpts.slug
		post.cursor = ajaxOpts.cursor
		store.commit('pushToSections', post)
    store.commit('updateLoadingHeader', {
      show: false
    })
		store.commit('showOutro', true)
		renderGalleries()
		if (callback) callback()
	}).catch(function(error) {
		console.log(error)
	})

}

function doLinkScroll() {

	return new Promise((resolve) => {

		Vue.nextTick(() => {

			// Calculate how far to scroll

			let scrollTarget

			try {
				let lastChild = $('main').children('.loading').get()
				scrollTarget = $(lastChild).offset().top - 1
			} catch (e) {
				scrollTarget = document.documentElement.scrollTop
			}

			scrollToPosition(scrollTarget, () => {
				resolve()
			})

		})

	})

}

function onClickDefaultLink(e) {

	e.preventDefault()
	e.stopImmediatePropagation()

	store.commit('progressBarEnabled', false)
	store.commit('showOutro', false)

  let wasSidebarLink

	if ($(e.currentTarget).data('cursor') == 'circle') {
    wasSidebarLink = true
  } else {
    wasSidebarLink = false
  }

	// TODO: Up arrow should only show on new kula. This needs to be done in a cleaner way.

	if (!store.state.loopHelper.showUpArrow) {
		vm.$refs['up-arrow'].flash()
		store.commit('showUpArrow', true)
	}

	if (wasSidebarLink) {
		store.commit('showUpArrow', false)
	}

	$(e.currentTarget).addClass('ajax--clicked')

	// If sidebar, update menu state

	if (wasSidebarLink) updateMenuState(e)

	// Update loading header

	store.commit('updateLoadingHeader', {
		cursor: $(e.currentTarget).data('cursor'),
		color: $(e.currentTarget).data('color'),
		show: true
	})

	let opts = {
		id: $(e.currentTarget).data('id'),
		type: $(e.currentTarget).data('type'),
		cursor: $(e.currentTarget).data('cursor'),
		color: $(e.currentTarget).data('color'),
		slug: $(e.currentTarget)[0].pathname,
    scrollTop: $('#main').height()
	}

	Vue.nextTick(() => {
		doLinkScroll().then(() => {
			doRequest(opts, () => {
				if (wasSidebarLink) {
					$(window).scrollTop(0)
					store.commit('clearPreviousSections')
				}
				store.commit('showOutro', true)
			})
		})
	})

  console.log('hej')
  console.log(opts.scrollTop)

	history.pushState({
		scrollTop: opts.scrollTop,
		path: opts.slug
	}, opts.slug, opts.slug)

}

function renderGalleries() {
	Vue.nextTick(() => {
		let thumbs = $('.img-placeholder--unrendered')
		for (let thumb of thumbs) {
			let bg = 'url(' + $(thumb).data('thumb-src') + ')'
			$(thumb).removeClass('img-placeholder--unrendered')
			$(thumb).css('background-image', bg)
		}
	})
}

function onClickIntroLink(e) {
	e.preventDefault()
	e.stopImmediatePropagation()

	updateMenuState(e)

	$(e.currentTarget).addClass('menu-link--selected')

	store.commit('isIntro', false)
	store.commit('introPadding', true)

	store.commit('updateLoadingHeader', {
		cursor: $(e.currentTarget).data('cursor'),
		color: $(e.currentTarget).data('color'),
		show: true
	})

	store.commit('showOutro', false)

	let opts = {
		id: $(e.currentTarget).data('id'),
		type: $(e.currentTarget).data('type'),
		cursor: $(e.currentTarget).data('cursor'),
		color: $(e.currentTarget).data('color'),
		slug: $(e.currentTarget)[0].pathname,
		wasIntro: true,
		scrollTop: 0
	}

	function introComplete(e) {
		e.stopImmediatePropagation()
		store.commit('showIntro', false)
		store.commit('showOutro', true)
		Vue.nextTick(() => {
			$(window).scrollTop(0)
		})
	}

	setTimeout(() => {

		store.commit('pixelHasFadeOut', true);

		doLinkScroll().then(() => {

			// Fixes jumping on iOS
			if (isMobile.any()) store.commit('showIntro', false)

			Vue.nextTick(doRequest(opts, function() {

				Vue.nextTick(function() {
					let elem = $('main').find('.section-body').first()
					store.commit('introAnimation', true)
					store.commit('introPadding', false)
					elem.one('webkitAnimationStart oanimationstart msAnimationStart animationstart', introComplete)
				})

			}))
		})

	}, 400);

	history.pushState({
		scrollTop: opts.scrollTop,
		path: opts.slug
	}, opts.slug, opts.slug)

}

function onClickOutroLink(e) {
	e.preventDefault()
	e.stopImmediatePropagation()

	updateMenuState(e)

	store.commit('showUpArrow', false)
	store.commit('dismissOutro', true)

	let opts = {
		id: $(e.currentTarget).data('id'),
		type: $(e.currentTarget).data('type'),
		cursor: $(e.currentTarget).data('cursor'),
		color: $(e.currentTarget).data('color'),
		slug: $(e.currentTarget)[0].pathname,
		scrollTarget: document.documentElement.scrollTop
	}

	let eventType

	window.sashimi.isMobileWidth || store.state.mobile ? eventType = 'animationend' : eventType = 'transitionend'

	$('.outro').one(eventType, () => {

		store.commit('clearSections')

		//this.fire = false

		store.commit('showOutro', false)

		Vue.nextTick(() => {
			store.commit('dismissOutro', false)
			store.commit('fixOutro', false)
		})

		Vue.nextTick(doRequest(opts, () => {
			document.documentElement.scrollTop = 0
			Vue.nextTick(() => {
				store.commit('showOutro', true)
				document.documentElement.scrollTop = 0
			})
		}))

	})

	history.pushState({
		scrollTop: opts.scrollTop,
		path: opts.slug
	}, opts.slug, opts.slug)

}

const eventBus = new Vue()

let util = {
	scrollToPosition: scrollToPosition,
	updateMenuState: updateMenuState,
	getAll: getAll,
	getSingle: getSingle,
	getTaggedPosts: getTaggedPosts,
	getPage: getPage,
	getTimeline: getTimeline,
	getLexicon: getLexicon,
	getAuthors: getAuthors,
	getAuthorMeta: getAuthorMeta,
	getPermalinkFromID: getPermalinkFromID,
	getMultilineTitleFromID: getMultilineTitleFromID,
	getSingleAuthor: getSingleAuthor,
	getSingleLexicon: getSingleLexicon,
	getSingleTimeline: getSingleTimeline,
	onClickDefaultLink: onClickDefaultLink,
	onClickOutroLink: onClickOutroLink,
	onClickIntroLink: onClickIntroLink,
	getRandomColor: getRandomColor,
	detectMobile: _detectMobile,
	eventBus: eventBus,
	loading: false,
	setupAjax: setupAjax,
	getMenus: getMenus,
	renderGalleries: renderGalleries
}

export default util
